module.exports = __webpack_public_path__ + "img/c3ae834.jpg";